import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';


if(environment.production){
  const methods =['info','debug','log','warn'];
    methods.forEach(me=>{
      (console as any)[me]=()=>{};
    });
}
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
